var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartWithCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M36.9,10.4c-3.8-3.7-9.8-3.7-13.6,0l-0.8,0.8l-0.8-0.8c-3.8-3.7-9.8-3.7-13.6,0C4.4,14.1,4.3,20.1,8,23.8 c0,0,0,0,0.1,0.1l13.1,13c0.7,0.7,1.9,0.7,2.6,0l4-4h-2.6c-0.7,0-1.4-0.2-2-0.6c-1.4-0.9-2-2.6-1.5-4.1c0.5-1.5,1.9-2.6,3.5-2.6 h2.7v-2.7c0-1.6,1.1-3.1,2.7-3.5c1.5-0.4,3.2,0.2,4,1.6c0.4,0.6,0.6,1.2,0.6,1.9v2.7l1.7-1.7C40.6,20.2,40.7,14.2,36.9,10.4 C36.9,10.4,36.9,10.4,36.9,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M31.5,37.3c0,0,0.1,0,0.1,0c1,0,1.7-0.7,1.8-1.7v-4.5h4.5c0.9,0,1.7-0.8,1.7-1.7c0,0,0-0.1,0-0.1 c0-1-0.7-1.7-1.7-1.8h-4.5v-4.6c0-0.2,0-0.4-0.1-0.5c-0.2-0.9-1.1-1.4-2-1.3c-0.9,0.1-1.6,0.9-1.5,1.8v4.6h-4.6 c-0.9,0-1.7,0.6-1.8,1.5c-0.1,0.9,0.4,1.7,1.2,2h5.2v4.6C29.8,36.5,30.6,37.3,31.5,37.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartWithCross);
export default __webpack_public_path__ + "static/media/heart_with_cross.d9d7b4a6b1d51c5843fed975a78947e1.svg";
export { ForwardRef as ReactComponent };